import { Route } from "react-router-dom";
import ClientHome from "../components/index";

const ClientHomeRoutes = () => (
  <>
    <Route path="/" element={<ClientHome />} />
  </>
);


export default ClientHomeRoutes;
